// om sai ram

import loadScript from './loadScript';
import app from './app';
import errorHandler from './errorHandler';
import { isProductPage, isCartPage } from './utils';
import { isDevMode } from './devMode';
let loadJquery = false;
if (IS_LOGGING) {
  loadLogging();
}
if (typeof jQuery === 'undefined') {
  loadJquery = true;
} else {
  const ver = parseFloat(
    jQuery.fn.jquery.substring(0, jQuery.fn.jquery.lastIndexOf('.'))
  );

  if (ver >= 2.2) {
    window.jUpsell = jQuery;
    loadApp();
  } else {
    loadJquery = true;
  }
}

if (loadJquery) {
  loadScript(
    '//ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js',
    function() {
      window.jUpsell = jQuery.noConflict(true);
      loadApp();
    }
  );
}

function loadApp() {
  try {
    //createSlider();
    isDevMode();
    if (isProductPage() || isCartPage()) {
      app();
    }
  } catch (err) {
    errorHandler(err);
  }
}

function loadLogging() {
  loadScript(
    '//browser.sentry-cdn.com/5.6.3/bundle.min.js',
    function() {
      Sentry.init({
        dsn: 'https://4b699a2a5cfc407f8f3016fc44e55814@sentry.io/1762810',
        environment: 'prod',
        defaultIntegrations: false
      });
    },
    {
      integrity:
        'sha384-/Cqa/8kaWn7emdqIBLk3AkFMAHBk0LObErtMhO+hr52CntkaurEnihPmqYj3uJho',
      crossOrigin: 'anonymous'
    }
  );
}
